import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";

export const AdminPage = ({ title, subtitle, action, actionLabel, children }) => (
  <Box maxW="1200px" mx="auto" px={[4, 6, 8]} py={[6, 10]}>
    <Flex
      alignItems={["flex-start", "center"]}
      justifyContent="space-between"
      flexDir={["column", "row"]}
      gap={3}
      mb={6}
    >
      <Box>
        <Heading
          fontSize={["1.4rem", "1.8rem"]}
          color="green.700"
          borderLeft="4px solid"
          borderColor="green.400"
          pl={4}
        >
          {title}
        </Heading>
        {subtitle && (
          <Text color="gray.500" pl={4} mt={1} fontSize="0.9rem">
            {subtitle}
          </Text>
        )}
      </Box>
      {action && (
        <Button colorScheme="green" onClick={action} flexShrink={0}>
          {actionLabel}
        </Button>
      )}
    </Flex>

    <Box
      bg="white"
      borderRadius="1.25rem"
      boxShadow="0 2px 12px rgba(0,0,0,0.07)"
      border="1px solid"
      borderColor="gray.100"
      overflow="hidden"
    >
      {children}
    </Box>
  </Box>
);

export default AdminPage;
